import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history/19th_Century_-_Unification_of_Germany_and_Italy.png';

function HistoryPageUnificationGermanyItalyGo() {
  return (
    <QuizPage
      title="History: Unification of Germany and Italy"
      subTopic="Unification of Germany and Italy"
      backgroundImage={historyImage}
      returnPath="/History-Unification-Germany-Italy"
    />
  );
}

export default HistoryPageUnificationGermanyItalyGo;
